export default "__VITE_ASSET__BMg9Lh18__"